import { MeContext } from 'contexts/me'
import UserCard from 'components/UserCard'
import Table from 'components/table'
import TableItem from 'components/TableItem'
import Skeleton from 'react-loading-skeleton'
import { v4 as uuid } from 'uuid'
import { useContext } from 'react'

export default function ProfileUserData() {
  const { me } = useContext(MeContext)

  const profileProperties = [
    {
      label: 'Nombre',
      value: `${me?.profile.name.toLowerCase()} ${me?.profile.surname.toLowerCase()}`
    },
    {
      label: me?.profile.identification_type,
      value: me?.profile.identification_number
    },
    {
      label: 'Email',
      value: me?.profile.email
    },
    {
      label: 'Celular',
      value: me?.profile.phone
    },
    {
      label: 'CVU',
      value: me?.bank.internal_account[0].cvu
    }
  ]

  return (
    <>
      <UserCard layoutProfile />
      {me ? (
        <Table className='!px-3 sm:px-6'>
          {profileProperties.map((item, index) => (
            <TableItem
              {...item}
              key={uuid()}
              valueClassName='text-[0.938rem] sm:text-base'
              className={index === 0 && 'capitalize'}
            />
          ))}
        </Table>
      ) : (
        <Skeleton height={260} width={564} />
      )}
    </>
  )
}
